import {
  detectRequestTypeFromDescription,
  getRequestGroupKey,
  getRequestGroupLabel,
} from './requestTypeLabels';

function truncate(text, max = 72) {
  if (!text || typeof text !== 'string') return text;
  return text.length > max ? `${text.slice(0, max)}…` : text;
}

/** Текст запроса из description задачи */
export function extractTaskQuery(description) {
  if (!description || typeof description !== 'object') return '—';

  const d = description;
  const textFields = [
    d.name,
    d.requests,
    d.konstruktor,
    d.konstruktor_req,
    d.konstruktor_wipo,
    d.wipoName,
    d.adress,
    d.adressReq,
    d.wipoAdres,
    d.patentObl,
    d.patentOblRequests,
    d.wipoObl,
    d.description,
    d.description_tz,
    d.description_req,
    d.description_wipo,
    d.description_elastic,
  ];

  for (const val of textFields) {
    if (typeof val === 'string' && val.trim()) {
      return truncate(val.trim());
    }
  }

  if (d.imageName) return `Изображение: ${d.imageName}`;
  if (d.image || d.imageReq || d.imageWipo) return 'Поиск по изображению';
  if (d.yandexImageSearch || d._yandexImageUrl) return 'Глобальный поиск по изображению';

  if (Array.isArray(d.mktu) && d.mktu.length) {
    return `МКТУ: ${d.mktu.slice(0, 5).join(', ')}${d.mktu.length > 5 ? '…' : ''}`;
  }

  return '—';
}

/** Категория поиска для задачи */
export function getTaskSearchLabel(task) {
  const types = task?.request_types || [];
  if (types.length) {
    const labels = [...new Set(types.map((t) => getRequestGroupKey(t)))].map(getRequestGroupLabel);
    return labels.join(', ');
  }
  const type = detectRequestTypeFromDescription(task?.description);
  if (type === 'yandexImageSearch') return 'Глобальный поиск';
  if (type) return getRequestGroupLabel(getRequestGroupKey(type));
  return 'Поиск';
}

/** Статус задачи по её запросам */
export function getTaskStatusMeta(task) {
  const total = Number(task?.requests_count) || 0;
  const errors = Number(task?.errors_count) || 0;
  const completed = Number(task?.completed_count) || 0;
  const pending = Number(task?.pending_count) || 0;

  if (!total) return { label: 'Без запросов', color: 'default' };
  if (errors > 0) return { label: 'Ошибка', color: 'error' };
  if (pending > 0) return { label: 'В процессе', color: 'processing' };
  if (completed >= total) return { label: 'Готово', color: 'success' };
  return { label: 'В процессе', color: 'processing' };
}
